import { Routes } from '@angular/router';

export const REGULATIONS_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/regulations-index/regulations-index.component').then(
            (x) => x.RegulationsIndexComponent
          ),
      },
    ],
  },
];
